import { useTranslation } from "react-i18next";
import type { Renditebruecke } from "../../lib/otterfolio";
import { OTTERFOLIO_THEME } from "./theme";

interface Props {
  rb: Renditebruecke | null;
}

function isEmpty(rb: Renditebruecke): boolean {
  return (
    rb.breakdown.wachstum === 0 && rb.breakdown.ausschuettung === 0 && rb.breakdown.bewertung === 0
  );
}

export function RenditebrueckeBadge({ rb }: Props) {
  const { t } = useTranslation();
  if (!rb || isEmpty(rb)) {
    return (
      <span style={{ fontSize: 10, color: OTTERFOLIO_THEME.textMuted }}>
        {t("otterfolio.renditebruecke.abbrev")}: —
      </span>
    );
  }
  const badge = rb.overHurdle ? "🟢" : "🟡";
  const color = rb.overHurdle ? OTTERFOLIO_THEME.primary : OTTERFOLIO_THEME.highlight;
  const sign = rb.bruecke >= 0 ? "+" : "";
  return (
    <span
      title={`${t("otterfolio.renditebruecke.hurdle")}: ${rb.hurdle.toFixed(1)} %`}
      style={{ fontSize: 10, color, fontWeight: 700, whiteSpace: "nowrap" }}
    >
      {t("otterfolio.renditebruecke.abbrev")}: {sign}
      {rb.bruecke.toFixed(1)} % {badge}
      {rb.stale ? " ⚠️" : ""}
    </span>
  );
}
